import React from "react";
import dayjs from "dayjs";
import CustomTable from "../../../../../../layout/components/customTable";
import { useHistory, useLocation } from "react-router-dom";
import { SessionVariables } from "../../../../../../core/constants/SessionVariables";
import { SessionStorage } from "../../../../../../core/helpers/localStorage/sessionStorage";
import { getBreadCrumbSession } from "../../../../../../core/helpers/localStorage/breadCrumbSession";
import WatchlistTitleContainer from "../../../../admin/watchlist/components/watchlistTable/components/WatchlistTitleContainer";
import WatchlistRatingColumnComponent from "../../../../admin/watchlist/components/watchlistTable/components/WatchlistRatingColumnComponent";
import HistoricalChart from "../../../../../../layout/components/rechart/tiny-chart/HistoricalChart";
import WatchlistPredictionChart from "../../../../../../layout/components/rechart/tiny-chart/WatchlistPredictionChart";
import ActionsContainer from "../../../../admin/watchlist/components/watchlistTable/components/ActionsContainer";
import DashboardActionButtons from "../../components/dashboardActions";
import { defaultDashboardScrollPosition } from "../../../../../../core/constants/tableScrollConstants";
import { usePromiseTracker } from "react-promise-tracker";
import RenderSvg from "../../../../../../layout/components/icons/RenderSvg";
import { getRouteByCategory } from "../../../../../../core/helpers/dasboardRoute";
import { DashboardApi } from "../../../../../../core/api/dashboardApi";
import { TrackedItemsVariables } from "../../../../../../core/constants/TrackedItemsConstants";
var localizedFormat = require("dayjs/plugin/localizedFormat");
dayjs.extend(localizedFormat);
const CompaniesListing = ({ companies, scaleBandArray, currentPage, pageSize, handleCustomTablePropChange = null, selectedFrequency = null, isPrintMode = false, openNotificationModal = null, handleToggleWatchListModal = null, userId = null, dashboardHierarchy = null, }) => {
    const history = useHistory();
    const { BREADCRUMB } = SessionVariables;
    const { setKey, getKey } = SessionStorage;
    const { pathname } = useLocation();
    const handleRowClick = (record) => {
        const { trackedItemCompanyId, itemName, hierarchy, currentRatingInfoDTO } = record;
        // if (overallBandInfoDTO?.status) {
        let breadCrumbList = getBreadCrumbSession();
        DashboardApi.getParentData([trackedItemCompanyId]).then((res) => {
            var _a;
            const { groupId } = res[trackedItemCompanyId];
            // setPrevBreadcrumbPath(breadCrumbList);
            breadCrumbList = [
                ...breadCrumbList,
                {
                    path: `/${+trackedItemCompanyId}`,
                    name: itemName,
                    category: `${hierarchy} Dashboard`,
                    bandName: (record === null || record === void 0 ? void 0 : record.weight) !== 0
                        ? // && !record?.weightFlag
                            currentRatingInfoDTO === null || currentRatingInfoDTO === void 0 ? void 0 : currentRatingInfoDTO.currentStatus
                        : "E",
                    bandColor: (record === null || record === void 0 ? void 0 : record.weight) === TrackedItemsVariables.UnrateableCode
                        ? TrackedItemsVariables.UnrateableColor
                        : (_a = currentRatingInfoDTO === null || currentRatingInfoDTO === void 0 ? void 0 : currentRatingInfoDTO.currentStatusRgb) !== null && _a !== void 0 ? _a : "lightgrey",
                    parentPath: getRouteByCategory(record, groupId, trackedItemCompanyId),
                    key: record === null || record === void 0 ? void 0 : record.itemId,
                },
            ];
            setKey(BREADCRUMB, breadCrumbList, sessionStorage);
            if (SessionStorage.getKey(SessionVariables.EXPANDED_KEYS, sessionStorage) !== null) {
                const ids = getKey(BREADCRUMB, sessionStorage).map((item) => parseInt(item.key));
                setKey(SessionVariables.EXPANDED_KEYS, (ids === null || ids === void 0 ? void 0 : ids.length) > 0 ? ids : undefined, sessionStorage);
            }
            history.push(`${pathname}/${+trackedItemCompanyId}`);
            // }
        });
    };
    const columns = [
        {
            fieldName: "itemName",
            title: ["Company.companies"],
            className: "w-10 watchlistTitleColum ",
            width: 20,
            searchable: true,
            sortable: true,
            render: (row, data) => (React.createElement(React.Fragment, null,
                React.createElement(WatchlistTitleContainer, { row: row, data: data }),
                React.createElement(WatchlistRatingColumnComponent, { row: row, data: data, cardText: "Company Value" }))),
        },
        {
            fieldName: "historyChartDTOList",
            title: ["Dashboard.historicalPerformance"],
            className: "w-30 watchlistChartColum",
            width: 27,
            align: "center",
            render: (row, data) => (React.createElement(React.Fragment, null,
                React.createElement(HistoricalChart, { data: data, row: row, frequency: +(selectedFrequency === null || selectedFrequency === void 0 ? void 0 : selectedFrequency.code), isDashboard: true, weight: data === null || data === void 0 ? void 0 : data.weight, weightFlag: data === null || data === void 0 ? void 0 : data.weightFlag }))),
        },
        {
            fieldName: "predictedBandInfoDTO",
            title: (React.createElement(React.Fragment, null,
                React.createElement("span", { className: "bold-content" }, "RodaBI"),
                "Prediction")),
            className: "w-30 watchlistPredictionColum",
            width: 26,
            align: "center",
            render: (data, row) => (React.createElement(WatchlistPredictionChart, { data: data, row: row, weight: row === null || row === void 0 ? void 0 : row.weight, weightFlag: row === null || row === void 0 ? void 0 : row.weighFlag })),
        },
        {
            fieldName: "notificationCount",
            title: ["Dashboard.criticalNotifications"],
            className: "w-15 watchlistActionColum",
            width: 12,
            align: "center",
            render: (row, data) => (React.createElement(ActionsContainer, { row: row, data: data, openMessageModal: openNotificationModal })),
        },
    ];
    const actionColumn = {
        fieldName: "actions",
        title: ["actions"],
        className: "w-5",
        width: 7,
        align: "center",
        render: (actions, row) => (React.createElement(React.Fragment, null, DashboardActionButtons(row, handleToggleWatchListModal, userId, "companyDashboardRatingTabDTOList"))),
    };
    const displayedColumns = [...columns, actionColumn];
    const { promiseInProgress } = usePromiseTracker({ area: "LoadMore" });
    return (React.createElement("div", { className: "customListing watchlistTable", "data-test": "companies-listing-table" },
        React.createElement("div", { className: "watchlistLoading align-content-center justify-content-center row", hidden: !promiseInProgress },
            React.createElement(RenderSvg, { icon: "Loader" })),
        React.createElement(CustomTable, { data: companies, columns: displayedColumns, dataType: "any", scroll: true, scrollPosition: defaultDashboardScrollPosition, clientPagination: false, serverSearching: true, serverSorting: true, customTablePropChange: handleCustomTablePropChange, searchAllColumn: false, rowClickHandler: handleRowClick })));
};
export default CompaniesListing;
